import React from 'react';
import { string, number, oneOfType, bool, func, array, node } from 'prop-types';
import { useDropzone } from 'react-dropzone';
import './FileInput.scss';

const FileInput = ({ accept, children, disabled, noDrag, onDrop, maxSize, ...props }) => {
  const { getRootProps, getInputProps } = useDropzone({
    accept,
    noDrag,
    disabled,
    // onDrop: acceptedFiles => {
    //   let files = null;

    //   if (!acceptedFiles.length) {
    //     return false;
    //   }

    //   if (maxSize) {
    //     files = acceptedFiles.filter(c => !(c && c.size > maxSize));
    //   }

    //   onDrop(files);

    //   return false;
    // },
    onDrop: acceptedFiles => {
      if (!!acceptedFiles.length && maxSize) {
        const files = acceptedFiles.filter(c => !(c && c.size > maxSize));
        onDrop(files);
      }
    },
  });

  return (
    <div
      {...getRootProps({
        className: 'FileInput',
      })}
      {...props}
    >
      <input {...getInputProps()} />
      {children}
    </div>
  );
};

FileInput.defaultProps = {
  accept: '',
  noDrag: true,
  disabled: false,
  maxSize: 20 * 1e6, // 20MB
  onDrop: () => {},
};

FileInput.propTypes = {
  accept: oneOfType([string, array]),
  children: node.isRequired,
  disabled: bool,
  noDrag: bool,
  onDrop: func,
  maxSize: oneOfType([string, number]),
};

export default FileInput;
